export default "skymp5-front/1da0f424d3342e85f52d586f2a472ccc.png";